import {CompareChildren} from "./CompareChildren";

import {CompareItem} from "./CompareItem";

import {CompareMonthCellsProvider} from "./CompareMonthCells";

import {useEffect, useLayoutEffect, useRef, useState} from "react";

import {STICKY_TH} from "./slaCompareStickyClasses";
import {findSlaMonthData} from "../slaCompareMonthUtils";

import "../slaCompare.css";

function SlaCompareRegisterIcon({size = 12}) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M12 4a1 1 0 0 1 1 1v6h6a1 1 0 0 1 0 2h-6v6a1 1 0 0 1 -2 0v-6h-6a1 1 0 0 1 0 -2h6v-6a1 1 0 0 1 1 -1"/>
        </svg>
    );
}

function SlaCompareEditIcon({size = 12}) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
        >
            <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
            <path d="M7 10h3v-3l-3.5 -3.5a6 6 0 0 1 8 8l6 6a2 2 0 0 1 -3 3l-6 -6a6 6 0 0 1 -8 -8l3.5 3.5"/>
        </svg>
    );
}



function CompareTable({data, date, onOpenEditor, onNavigateDetail}){



    const [dateList, setDateList] = useState();
    const tableRef = useRef(null);
    const [tableHeight, setTableHeight] = useState(0);

    useLayoutEffect(() => {
        const table = tableRef.current;
        if (!table) return;

        const updateHeight = () => setTableHeight(table.offsetHeight);
        updateHeight();

        const observer = new ResizeObserver(updateHeight);
        observer.observe(table);
        return () => observer.disconnect();
    }, [data, dateList]);



    useEffect(() => {
        buildCurrentYearMonthList();
    }, []);

    function buildCurrentYearMonthList() {
        const year = new Date().getFullYear();
        const result = [];

        for (let month = 1; month <= 12; month++) {
            const monthStr = String(month).padStart(2, "0");
            result.push({
                date: `${year}년 ${monthStr}월`,
                id: `${year}-${monthStr}`,
            });
        }

        setDateList(result);
    }



    return (

        <>

            <div className="sla-compare-table-wrap">
                {tableHeight > 0 && (
                    <div
                        className="sla-compare-sticky-divider"
                        style={{height: tableHeight}}
                        aria-hidden="true"
                    />
                )}
                <CompareMonthCellsProvider data={data} dateList={dateList}>
                    <table ref={tableRef} className="sla-compare-table">

                        <colgroup>

                            <col className="sla-compare-col--1"/>

                            <col className="sla-compare-col--2"/>

                            <col className="sla-compare-col--3"/>

                            <col className="sla-compare-col--4"/>

                            {dateList?.map((each) => (

                                <col key={each.id} className="sla-compare-col--month"/>

                            ))}

                        </colgroup>

                        <thead>

                            <tr>

                                <th className={STICKY_TH.c1}>서비스 구분</th>

                                <th colSpan={2} className={STICKY_TH.c2_3}>측정지표</th>

                                <th className={STICKY_TH.c4}>산출내역</th>

                                {

                                    dateList && dateList.map((each) => {

                                        const raw = findSlaMonthData(data, each.id);

                                        return (

                                            <th className="fieldset-th sla-compare-month-th sla-compare-month-col" key={each.id}>

                                                <div className="sla-compare-month-th__inner">

                                                    {raw?.id && onNavigateDetail ? (
                                                        <button
                                                            type="button"
                                                            className="sla-compare-month-th__label sla-compare-month-th__label--link"
                                                            onClick={() => onNavigateDetail(raw, each.date)}
                                                        >
                                                            {each.date}
                                                        </button>
                                                    ) : (
                                                        <span className="sla-compare-month-th__label">{each.date}</span>
                                                    )}

                                                    {raw ? (

                                                        <button

                                                            type="button"

                                                            className="sla-compare-month-th__edit"

                                                            title="수정"

                                                            aria-label={`${each.date} 수정`}

                                                            onClick={() => onOpenEditor?.("update", raw.month, each.date)}

                                                        >

                                                            <SlaCompareEditIcon size={12}/>

                                                        </button>

                                                    ) : (

                                                        <button

                                                            type="button"

                                                            className="sla-compare-month-th__register"

                                                            title="등록"

                                                            aria-label={`${each.date} 등록`}

                                                            onClick={() => onOpenEditor?.("create", each.id, each.date)}

                                                        >

                                                            <SlaCompareRegisterIcon size={14}/>

                                                        </button>

                                                    )}

                                                </div>

                                            </th>

                                        );

                                    })

                                }

                            </tr>

                        </thead>

                        <tbody>

                            <CompareChildren data={data} dateList={dateList}/>

                            <CompareItem data={data} dateList={dateList}/>

                        </tbody>

                    </table>

                </CompareMonthCellsProvider>

            </div>

        </>

    )

}



export {CompareTable}

